import React, { useEffect, useState } from "react";
import {
  Box,
  Heading,
  Image,
  SimpleGrid,
  Stack,
  VStack
} from "@chakra-ui/react";

import DefaultAvatarImage from "assets/default-avatar.svg";
import { useUser } from "context/user";
import { fetchSessions } from "api/webservice/sessions";
import ProfileText, { Variant } from "components/ProfileText";
import { format } from "date-fns";

const ProfileCard: React.FC = () => {
  const { user } = useUser()!;
  const [sessionCount, setSessionCount] = useState(0);

  useEffect(() => {
    fetchSessions().then(sessions => setSessionCount(sessions.entryCount));
  }, []);

  return (
    <Box
      borderRadius="xl"
      width="100%"
      p={8}
      bg="gray.800"
      boxShadow="0px 4px 7px -1px rgba(0, 0, 0, 0.25)"
    >
      <Stack
        direction={["column", "row"]}
        spacing={[10, 20]}
        alignItems="center"
      >
        <Image
          bg="gray.700"
          borderRadius="2xl"
          boxSize="132px"
          src={""} // User's avatar image URL
          fallbackSrc={DefaultAvatarImage}
          alt={`${user.first_name} ${user.last_name} profile image`}
          boxShadow="0px 4px 7px -1px rgba(0, 0, 0, 0.25)"
        />
        <VStack spacing={4} alignItems="flex-start">
          <Heading as="h2" p={0}>
            {user.first_name} {user.last_name}
          </Heading>
          <SimpleGrid columns={[1, 2]} gap={10}>
            <ProfileText
              label="Sessions Scheduled"
              text={sessionCount.toString()}
              variant={Variant.LARGE}
            />
            <ProfileText
              label="Member Since"
              text={
                user?.createdAt ? format(new Date(user.createdAt), "MMM y") : ""
              }
              variant={Variant.LARGE}
            />
          </SimpleGrid>
        </VStack>
      </Stack>
    </Box>
  );
};

export default ProfileCard;
